import {
  fetchServers
} from '@/api/server'
import { fetchAccounts } from '@/api/account'

export default {
  state: {
    serverList: [],
    account: []
  },
  mutations: {
    setServerList(state, list) {
      state.serverList = list
    },
    setAccount(state, data) {
      state.account = data
    }
  },
  getters: {
    serverCount: state => state.serverList.length
  },
  actions: {
    // 获取服务器列表
    getServers({ state, commit }) {
      return new Promise((resolve, reject) => {
        fetchServers().then(res => {
          // commit('setServerList', unread.sort((a, b) => new Date(b.create_time) - new Date(a.create_time)))
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    getAccounts({ state, commit }) {
      return new Promise((resolve, reject) => {
        fetchAccounts().then(res => {
          commit('setAccount', res.data)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}
